<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->

// Collection Description Read More/Read Less
$(document).ready(function () {
  $(".bottom-toggle-btn").click(function () {
    var $desc = $(this).closest(".bottom-collection-description");
    var $shortText = $desc.find(".bottom-short-text");
    var $fullText = $desc.find(".bottom-full-text");

    if ($fullText.is(":visible")) {
      $fullText.slideUp();
      $shortText.slideDown();
      $(this).text($(this).data("read-more") || "Read More");
      $(".bottom-toggle-btn").addClass("readmore_desc_btn");
      $(".bottom-toggle-btn").removeClass("readless_desc_btn");
    } else {
      $shortText.slideUp();
      $fullText.slideDown();
      $(this).text($(this).data("read-less") || "Read Less");
      $(".bottom-toggle-btn").removeClass("readmore_desc_btn");
      $(".bottom-toggle-btn").addClass("readless_desc_btn");
    }
  });

     // New code for resetting quantity after Add to Cart
    $(document).on('click', 'form[action*="/cart/add"] [type="submit"], .add-to-cart, .product-form__submit', function() {
        var $qtyInput = $(this).closest('form').find('input[name="quantity"]');
        if ($qtyInput.length) {
            // Wait a bit so cart updates first, then reset
            setTimeout(function() {
                $qtyInput.val(1);
            }, 500);
        }
    });

});